class Modalhouse {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let speed = 3000;
    const modelhouse_Swiper = new Swiper('.modelhouse-Swiper', {
      loop: true,
      speed: 500,
      effect: 'fade',
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          let num = index + 1;
          return (
            '<div class="' + className + ' circle-pagination' + '"><div class="circle-pagination__inner"><svg class="anime" version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 45 45"><circle class="st0 svg-elem-1" cx="22.5" cy="22.5" r="21.5" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 1px;"></circle></svg><span class="en">' + '0' + num + '</span></div></div>'
          )
        },
      },
      on: {
        slideChange: function () {
          if (this.realIndex > 0) {
            this.params.autoplay.delay = speed - 500;
          }
        },
      },
    });
  }
}